import { useState } from "react";
import { ProjectCards, ProjectForm, ProjectIssueStats, ProjectRepoBind, ProjectsEmpty } from "../components/Projects";
import type { Project } from "../lib/project";
import { tx } from "../i18n";

/* ══ 패턴 페이지 › 프로젝트의 부품(t-in-port-work-projects) ══
   카드 목록 · 새 프로젝트 폼 · 빈 상태 둘 · 상세(이슈 현황 · 리포 묶기 — 관리자 · 읽기 전용). 서버를 안 부른다. */

const REPOS = [
  { id: "r1", label: "irolab-co/b3x-in" },
  { id: "r2", label: "irolab-co/mops-cmmn-code" },
  { id: "r3", label: "platform/api" },
];
const PROJECTS: Project[] = [
  { id: "in.b3x.app", name: "b3x-in", description: null, createdAt: "2026-10-26T00:00:00Z", repositoryIds: ["r1", "r2"], taskCount: 41, openTaskCount: 12, milestoneCount: 3, orgId: null },
  { id: "p-mvq2k1a8", name: "플랫폼 API", description: null, createdAt: "2026-10-26T00:00:00Z", repositoryIds: ["r3"], taskCount: 0, openTaskCount: 0, milestoneCount: 0, orgId: null }, // copy-ignore: 견본 자료
  { id: "ops", name: "운영", description: null, createdAt: "2026-10-26T00:00:00Z", repositoryIds: [], taskCount: 3, openTaskCount: 1, milestoneCount: 0, orgId: null }, // copy-ignore: 견본 자료
];
const label = (id: string) => REPOS.find((r) => r.id === id)?.label ?? id;

export function ProjectStates() {
  const noop = () => undefined;
  // 리포 묶기는 손으로 눌러 볼 수 있게 상태를 든다 — 저장은 서버 없이 그 자리에서.
  const [p, setP] = useState(PROJECTS[0]);
  const toggle = (rid: string) =>
    setP((x) => ({ ...x, repositoryIds: x.repositoryIds.includes(rid) ? x.repositoryIds.filter((y) => y !== rid) : [...x.repositoryIds, rid] }));
  return (
    <>
      <h3>{tx("pat.projects.cards")}</h3>
      <ProjectCards projects={PROJECTS} repoLabel={label} />
      <h3>{tx("pat.projects.form")}</h3>
      <ProjectForm onCreate={noop} onCancel={noop} />
      <h3>{tx("pat.projects.empty")}</h3>
      <div className="pat__grid">
        <ProjectsEmpty repos={3} canEdit onQuick={noop} />
        <ProjectsEmpty repos={0} canEdit onQuick={noop} />
      </div>
      <h3>{tx("pat.projects.detail")}</h3>
      <div className="pat__grid">
        <ProjectIssueStats statuses={["done", "done", "in-progress", "review", "blocked", "todo", "todo", "cancelled"]} boardHref="#/board" />
        <ProjectIssueStats statuses={[]} boardHref="#/board" />
        <ProjectRepoBind p={p} repos={REPOS} canEdit onToggle={toggle} />
        <ProjectRepoBind p={PROJECTS[0]} repos={REPOS} canEdit={false} onToggle={noop} />
        <ProjectRepoBind p={PROJECTS[2]} repos={[]} canEdit onToggle={noop} />
      </div>
    </>
  );
}
